import { useState, useEffect, useContext } from 'react';
import api from './api/axiosInstance.js';
import { UserContext } from './UserContext';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Sidebar from './Sidebar.js';
import CompanyAddGeneral from './CompanyAddGeneral';
import CompanyAddAbout from './CompanyAddAbout';
import CompanyAddLegal from './CompanyAddLegal';
import CompanyAddSize from './CompanyAddSize';
import CompanyAddIndustries from './CompanyAddIndustries';
import CompanyAddBusinessType from './CompanyAddBusinessType';
import CompanyAddFortune from './CompanyAddFortune';
import CompanyAddStep2 from './CompanyAddStep2';
import { Card, Row, Col, Container, Image } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useNavigate } from 'react-router-dom';
import { validateURL} from './utils/validation';
import { isAdminType} from './utils/roleUtils';
import Breadcrumb from './Breadcrumb';
import icSucess from './assets/img/ic-celebration-circle.svg';
import Alert from 'react-bootstrap/Alert';

const AddCompany = () => {
    const { user } = useContext(UserContext);
    const [step, setStep] = useState(1);
    const navigate = useNavigate();
    const [showAddress2, setShowAddress2] = useState(false);
    const [isImageDeleted, setIsImageDeleted] = useState(false);
    const [validationAttempted, setValidationAttempted] = useState(false);
    const [isEditing, setIsEditing] = useState(true);
    const [formData, setFormData] = useState({
        type: '',
        title: '',
        legalName: '',
        phone: '',
        phone2: '',
        url: '',
        vat: '',
        activityStatus: false,
        country: '',
        country2: '',
        zip: '',
        zip2: '',
        city: '',
        cityRegion: '',
        city2: '',
        address: '',
        address2: '',
        houseNumber: '',
        latitude: '',
        longitude: '',
        latitude2: '',
        longitude2: '',
        globalSize: '',
        localSize: '',
        rating: '',
        continent: '',
        cityRegion: '',
        industry: '',
        industry2: '',
        industry3: '',
        subIndustry: '',
        subIndustry2: '',
        businessPurpose: '',
        localActivities: '',
        localStaffing: '',
        businessTypeOther: '',
        otherInformation: '',
        otherInformation2: '',
        hrFullName: '',
        hrRecrutingUrl: '',
        hrEmail: '',
        hrPhone: '',
        openedStudent: false,
        openedWorldTraveler: false,
        openedEnglishSpeaking: false,
        studentJobAreas: '',
        worldTravelerAreas: '',
        enSpeakingAreas: '',
        openJobsStudent: '',
        openJobsIntern: '',
        openJobsStarting: '',
        openJobs13: '',
        openJobs3: '',
        openJobsTotal: '',
        specialistAreas: '',
        studyDirections: '',
        bestPlacetoWork: false,
        bestPlacetoWorkRating: '',
        bestPlacetoWorkDescription: '',
        otherInformation1: '',
        initialRegistration: '',
        latestUserLogIn: '',
        latestDataUpdate: '',
        status:  '',
        accessLevel: '',
        logo: '',
        industries: [
            { industry: '', subIndustry: '', subIndustry2: [] }, // Default industry
        ],
        childUrl: '',
        childUrl2: '',
        globalUltimate: '',
        duns: '',
        ratingSource: '',
        isFortune: false,
        fortuneRank: '',
        fortuneYear: '',
        fortuneRevenue: '',
        fortunePercentChange: '',
        fortuneProfit: '',
        accountApprovalStatus: 'Approved',
        onboardingProgress: 50
    });

    const [errors, setErrors] = useState({});
    const [logo, setLogo] = useState(null);

    const [successModalTitle, setSuccessModalTitle] = useState('Congratulations');
    const [successModalMessage, setSuccessModalMessage] = useState('You have successfully added a new company to aBROADIFY.');

    const [tickets, setTickets] = useState([]);
    
    useEffect(() => {
        const fetchTickets = async () => {
            try {
                // ✅ goes through interceptor; token auto-attached
                const res = await api.get('/api/tickets'); // ✅
                setTickets(res.data);
            } catch (error) {
                console.error('Error fetching tickets:', error);
            }   
        };
        fetchTickets();
    }, []);

    const handleChange = (e) => {
        console.log('handleChange called with:', e.target.name, e.target.value);
        const { name, value, type, checked, files } = e.target;

        // Handle VAT validation
        if (name === 'vat') {
            if (!value.trim()) {
                setErrors((prevErrors) => ({ ...prevErrors, vat: 'VAT number is required.' }));
            } else {
                setErrors((prevErrors) => ({ ...prevErrors, vat: '' }));
            }
        }
        
        if (name === 'logo') {
            const file = (files && files[0]) || value;

            if (file instanceof File) {
                const fileUrl = URL.createObjectURL(file);

                // ✅ keep the File ONLY in this separate state
                setLogo(file);

                setFormData((prevData) => {
                    const updatedData = {
                        ...prevData,
                        // ❌ no File in formData
                        logoPreview: fileUrl, // ✅ what CompanyAddGeneral / About use
                    };

                    return {
                        ...updatedData,
                        onboardingProgress: calculateOnboardingProgress({
                            ...updatedData,
                            // if progress uses "has logo", use URL (string), not File
                            logo: fileUrl,
                        }),
                    };
                });
            }

            return;
        }
    
        // Handle industries and sub-industries dynamically
        if (name.startsWith('industry') || name.startsWith('subIndustry')) {
            const [key, index] = name.split('-');
            if (index) {
                setFormData((prevData) => {
                    const updatedIndustries = [...prevData.industries];
                    updatedIndustries[Number(index)][key] = value;
                    return {
                        ...prevData,
                        industries: updatedIndustries,
                        onboardingProgress: calculateOnboardingProgress(prevData), // Recalculate progress
                    };
                });
            } else {
                setFormData((prevData) => ({
                    ...prevData,
                    [key]: value,
                    onboardingProgress: calculateOnboardingProgress(prevData), // Recalculate progress
                }));
            }
            return;
        }

        // ✅ Fix: Ensure GPTW Rating is between 0 and 100
        if (name === 'bestPlacetoWorkRating') {
            const newValue = Math.min(100, Math.max(0, Number(value))); // ✅ Clamp value between 0-100
            setFormData((prevData) => ({
                ...prevData,
                bestPlacetoWorkRating: newValue,
            }));
            return;
        }
    
        // General fields (includes checkboxes)
        setFormData((prevData) => {
            const updatedData = {
                ...prevData,
                [name]: type === 'checkbox' ? checked : value,
                onboardingProgress: calculateOnboardingProgress({
                    ...prevData,
                    [name]: type === 'checkbox' ? checked : value,
                }), // Recalculate progress
            };
            return updatedData;
        });
    
        // Clear errors dynamically if the field is valid
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '', // Clear specific error for this field
        }));
    };

    const validateStep1 = (isEditing, showAddress2) => {
        const newErrors = {};

        // Required field validation for CompanyAddGeneral
        if (!formData.title.trim()) newErrors.title = 'Company name is required.';

        const trimmedURL = formData.url.trim();
        if (!trimmedURL) {
            newErrors.url = 'Company website is required.';
        } else if (!validateURL(trimmedURL)) {
            newErrors.url = 'Please enter a valid URL.';
        }

        // ✅ Add childUrl validation
        const trimmedChildUrl = formData.childUrl.trim();
        if (trimmedChildUrl && !validateURL(trimmedChildUrl)) {
            newErrors.childUrl = 'Please enter a valid URL.';
        }

        // Required field validation for CompanyAddAbout
        if (!formData.address.trim()) newErrors.address = 'Address is required.';
        if (!formData.country.trim()) newErrors.country = 'Country is required.';
        if (!formData.city.trim()) newErrors.city = 'City is required.';
        if (!formData.zip.trim()) newErrors.zip = 'ZIP Code is required.';
        // if (!formData.otherInformation.trim()) newErrors.otherInformation = 'Description is required.';

        // ✅ Conditionally validate address2 fields only if isEditing && showAddress2
        if (isEditing && showAddress2) {
            if (!formData.address2.trim()) newErrors.address2 = 'Address is required.';
            if (!formData.country2.trim()) newErrors.country2 = 'Country is required.';
            if (!formData.city2.trim()) newErrors.city2 = 'City is required.';
            if (!formData.zip2.trim()) newErrors.zip2 = 'ZIP Code is required.';
            if (!formData.otherInformation2.trim()) newErrors.otherInformation2 = 'Description is required.';
            
            const trimmedChildUrl2 = formData.childUrl2.trim();
            if (trimmedChildUrl2 && !validateURL(trimmedChildUrl2)) {
                newErrors.childUrl2 = 'Please enter a valid URL.';
            }

        }

        // Required field validation for CompanyAddLegal
        if (!formData.legalName.trim()) newErrors.legalName = 'Legal name is required.';
        if (!formData.vat.trim()) newErrors.vat = 'VAT number is required.';

        setErrors(newErrors);
        setValidationAttempted(true);
        console.log('Validation Errors:', newErrors);
        setShowErrorMessage(true);
        window.scrollTo({ top: 0, behavior: 'smooth' });

        return Object.keys(newErrors).length === 0;
    };


    const handleAddIndustry = () => {
        setFormData((prevData) => ({
            ...prevData,
            industries: [
                ...prevData.industries,
                { industry: '', subIndustry: '', subIndustry2: [] }, // Add a new industry object
            ],
        }));
    };

    const handleAddSubIndustry2 = (index) => {
        if (index === -1) {
            // Handle Sub Industry 2 for Industry 1
            setFormData({
                ...formData,
                subIndustry2: [...formData.subIndustry2, ''], // Add an empty string
            });
        } else {
            // Handle Sub Industry 2 for dynamic industries
            const updatedIndustries = [...formData.industries];
            updatedIndustries[index].subIndustry2 = [
                ...(updatedIndustries[index].subIndustry2 || []), // Ensure it's an array
                '', // Add an empty string for a new input field
            ];
            setFormData({ ...formData, industries: updatedIndustries });
        }
    };

    const handleIndustryChange = (index, field, value) => {
        setFormData((prevData) => {
            const updatedIndustries = [...prevData.industries];
    
            // Ensure the industry object exists at the given index
            if (!updatedIndustries[index]) {
                updatedIndustries[index] = { industry: '', subIndustry: '', subIndustry2: [] };
            }
    
            // Update the field
            if (field.startsWith('subIndustry2')) {
                const subIndex = field.match(/\[(\d+)\]/)[1]; // Extract index
                if (!updatedIndustries[index].subIndustry2) {
                    updatedIndustries[index].subIndustry2 = [];
                }
                updatedIndustries[index].subIndustry2[Number(subIndex)] = value;
            } else {
                updatedIndustries[index][field] = value;
            }
    
            return { ...prevData, industries: updatedIndustries };
        });
    };
    
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const [showErrorMessage, setShowErrorMessage] = useState(false);

    const [areasData, setAreasData] = useState({
        studyFields: [
            {
                studyField: '',
                preferredStudyDirections: '',
                specialistAreas: '',
            },
        ],
    });
    
    const handleAreasChange = (index, field, value) => {
        setAreasData((prev) => {
            const updated = [...prev.studyFields];
            updated[index] = { ...updated[index], [field]: value };

            return {
                ...prev,
                studyFields: updated,
            };
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        console.log('new company');

        try {
            const updatedFormData = { 
                ...formData, 
                activityStatus: true,
                studyFields: areasData.studyFields, // ✅ include specialist areas
            };

            const data = new FormData();
            Object.keys(updatedFormData).forEach((key) => {
                if (key === 'industries' || key === 'studyFields') {
                    data.append(key, JSON.stringify(updatedFormData[key])); // ✅ serialize arrays/objects
                } else {
                    data.append(key, updatedFormData[key]);
                }
            });

            const { _id } = updatedFormData;

            await api.put(
                `/api/companies/${_id}`,
                data,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            setShowSuccessModal(true);
        } catch (error) {
            console.error('Error updating company:', error);
            alert('An error occurred while updating the company. Please try again.');
        }
    };

    const calculateOnboardingProgress = (formData) => {
        // List all required fields for completion
        const requiredFieldsStep1 = [
            'logo',
            'title',
            'bestPlacetoWorkRating',
            'accessLevel',
            'url',
            'bestPlacetoWorkDescription',
            'address',
            'country',
            'city',
            'zip',
            'phone',
            'otherInformation',
            'childUrl',
            'legalName',
            'vat',
            'duns',
            'globalUltimate',
            'globalSize',
            'localSize',
            'rating',
            'ratingSource',
            'industries',
            'businessPurpose',
            'localActivities',
            'localStaffing',
            'businessTypeOther',
            'fortuneRank',
            'fortuneYear',
            'fortuneRevenue',
            'fortunePercentChange',
            'fortuneProfit',
        ];

        const requiredFieldsStep2 = [
            'hrFullName',
            // 'hrRecrutingUrl',
            // 'hrEmail',
            // 'hrPhone',
            // 'openedStudent',
            // 'openedWorldTraveler',
            // 'openedEnglishSpeaking',
            // 'studentJobAreas',
            // 'worldTravelerAreas',
            // 'enSpeakingAreas',
            // 'openJobsStudent',
            // 'openJobsIntern',
            // 'openJobsStarting',
            // 'openJobs13',
            // 'openJobs3',
            // 'specialistAreas',
            // 'studyDirections',
        ];

        const allRequiredFields = [...requiredFieldsStep1, ...requiredFieldsStep2];
    
        // Check if all required fields are filled
        const filledFields = allRequiredFields.every((field) => {
            const value = formData[field];
            if (field === 'logo') {
                return value !== null && value !== undefined; // Special handling for logo
            }
            if (typeof value === 'string') {
                return value.trim() !== ''; // Check for non-empty strings
            }
            if (typeof value === 'number') {
                return !isNaN(value); // Check for valid numbers
            }
            if (typeof value === 'boolean') {
                return value === true || value === false; // Check for boolean fields
            }
            if (Array.isArray(value)) {
                return value.length > 0; // Check for non-empty arrays
            }
            return !!value; // Check for other truthy values
        });

        return filledFields ? 100 : 50; // Return 100 if all fields are filled, else 50
    };
       
    if (!user || !isAdminType(user.role)) {
        return <div>You are not authorized to view this page.</div>;
    }

    const handleNextStep = async () => {
        if (step === 1) {
            const isValid = validateStep1(isEditing, showAddress2);
            if (!isValid) {
                console.log('Validation failed:', errors);
                return;
            }

            // ✅ Validation passed, hide error message
            setShowErrorMessage(false);

            // ✅ Validate VAT before submission
            if (formData.vat) {
                try {
                    const response = await api.post(
                        `/api/companies/check-vat`,
                        { vat: formData.vat }
                    );

                    if (response.data.exists) {
                        setErrors((prevErrors) => ({ ...prevErrors, vat: 'This VAT number is already registered.' }));
                        setShowErrorMessage(true); // ✅ Show error if VAT exists
                        return;
                    }
                } catch (error) {
                    console.error('Error checking VAT:', error);
                    setShowErrorMessage(true); // ✅ Show error on API failure
                    return;
                }
            }

            // ✅ Create company (POST)
            try {
                const data = new FormData();
                Object.keys(formData).forEach((key) => {
                    if (key === 'industries') {
                        data.append(key, JSON.stringify(formData[key]));
                    } else {
                        data.append(key, formData[key]);
                    }
                });

                if (logo) {
                    data.append('logo', logo);
                }

                const response = await api.post(
                    `/api/companies`,
                    data,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                        },
                    }
                );

                console.log('Company created:', response.data);

                const newId = response.data._id;
                if (!newId) {
                    console.error('❌ Company creation did not return an _id');
                    alert('Company creation failed: no ID returned.');
                    setShowErrorMessage(true); // ✅ Show error if no ID
                    return;
                }

                // ✅ Await state update before next step
                await new Promise((resolve) => {
                    setFormData((prevData) => {
                        resolve();
                        return { ...prevData, _id: newId };
                    });
                });

            } catch (error) {
                console.error('Error creating company:', error);
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    general: error.response?.data?.message || 'An error occurred while creating the company.',
                }));
                setShowErrorMessage(true); // ✅ Show error on API failure
                return;
            }
        }

        // ✅ Only increment step if _id is available
        setStep((prevStep) => prevStep + 1);
    };

   
    
    const handlePreviousStep = () => setStep((prevStep) => prevStep - 1);

    const handleDeleteImage = () => {
        setLogo(null);
        setFormData((prevData) => ({
            ...prevData,
            logoPreview: '',
        }));
        setIsImageDeleted(true); // ✅ mark as deleted
        console.log('delete')
    };
    
    return (
        <>
            <Sidebar ticketCount={tickets.length} />
            <main className="main-content flex-grow-1">
                <Container>
                    <Row>
                        <Col>
                            {showErrorMessage && (
                                <Alert variant="danger" onClose={() => setShowErrorMessage(false)} dismissible>
                                    <p><strong>Error</strong> - There are items that require your attention</p>
                                </Alert>
                            )}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Breadcrumb />
                        </Col>
                    </Row>
                    <Form onSubmit={step === 2 ? handleSubmit : undefined}>
                        <Row>
                            {step === 1 && (
                                <Col>
                                    <Card>
                                        <Card.Body className="pt-0">
                                            <Row>
                                                <Col xs={12}>
                                                    <>
                                                        <Row className="mb-5">
                                                            <Col>
                                                                <CompanyAddGeneral
                                                                    formData={formData}
                                                                    handleChange={handleChange}
                                                                    logo={formData.logoPreview || logo}
                                                                    errors={errors}
                                                                    validateURL={validateURL}
                                                                    isEditPage={false}
                                                                    handleDeleteImage={handleDeleteImage}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row className="mb-5">
                                                            <Col><h2>Company info</h2></Col>
                                                        </Row>
                                                        <Row className="mb-4">
                                                            <Col>
                                                                <CompanyAddAbout
                                                                    formData={formData}
                                                                    handleChange={handleChange}
                                                                    errors={errors}
                                                                    setErrors={setErrors}
                                                                    isEditPage={false}
                                                                    isEditing={isEditing}
                                                                    setIsEditing={setIsEditing}
                                                                    setShowAddress2={setShowAddress2}
                                                                    showAddress2={showAddress2}
                                                                    validationAttempted={validationAttempted}
                                                                    logo={formData.logoPreview || formData.logoUrl || formData.logo}
                                                                />
                                                            </Col>
                                                            <Col>
                                                                <CompanyAddLegal
                                                                    formData={formData}
                                                                    handleChange={handleChange}
                                                                    errors={errors}
                                                                    setErrors={setErrors}
                                                                    isEditPage={false}
                                                                />
                                                                <CompanyAddSize
                                                                    formData={formData}
                                                                    handleChange={handleChange}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row className="mb-4">
                                                            <Col>
                                                                {console.log('Rendering CompanyAddIndustries with:', formData.industries)}
                                                                <CompanyAddIndustries
                                                                    formData={formData}
                                                                    onAddIndustry={handleAddIndustry}
                                                                    onIndustryChange={handleIndustryChange}
                                                                    onAddSubIndustry2={handleAddSubIndustry2}
                                                                    industries={formData?.industries || []}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row className="mb-4">
                                                            <Col>
                                                                <CompanyAddBusinessType
                                                                    formData={formData}
                                                                    handleChange={handleChange}
                                                                />
                                                            </Col>
                                                        </Row>
                                                        <Row className="mb-4">
                                                            <Col>
                                                                <CompanyAddFortune
                                                                    formData={formData}
                                                                    handleChange={handleChange}
                                                                    setFormData={setFormData}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            )}
                            {step === 2 && 
                                <Col>
                                    <Card>
                                        <Card.Body className="pt-0">
                                            <Row>
                                                <Col xs={12}>
                                                    <>
                                                        <Row>
                                                            <CompanyAddStep2
                                                                formData={formData}
                                                                id={formData._id}
                                                                handleChange={handleChange}
                                                                setFormData={setFormData}
                                                                areasData={areasData}
                                                                handleAreasChange={handleAreasChange}
                                                                setAreasData={setAreasData}
                                                            />
                                                        </Row>
                                                    </>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>              
                                </Col>
                            }
                        </Row>
                        <Row className="buttons-row d-flex align-items-center">
                            <Col md={8}>
                                <p className="ms-3">All fields marked with an asterisk (<span>*</span>) are mandatory and must be completed.</p>
                            </Col>
                            <Col className="justify-content-end d-flex align-items-center" md={4}>
                                <Button className="me-3 px-5" variant="outline-secondary" onClick={() => navigate('/onboarding-company-list')}>
                                    Cancel
                                </Button>
                                {step > 1 && <Button className="me-3 px-5" variant="outline-secondary" onClick={handlePreviousStep}>Back</Button>}
                                {step === 1 && <Button className="px-5 me-3" variant="primary" onClick={handleNextStep}>Next</Button>}
                                {step === 2 && <Button className="px-5 me-3" variant="primary" type="submit">Finish</Button>}
                            </Col>
                        </Row>
                    </Form>
                </Container>
            </main>

            {/* Success Modal */}
            <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Image
                        src={icSucess}
                        alt=""
                        className="d-block m-auto mb-4"
                    />
                    <h2 className="text-center mb-3">{successModalTitle}</h2>
                    <p className="text-center">{successModalMessage}</p>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center">
                    <Button variant="primary" onClick={() => navigate('/onboarding-company-list')}>
                        Go to Companies
                    </Button>
                </Modal.Footer>
            </Modal>;
        </> 
    );
};

export default AddCompany;
